module.exports = __webpack_public_path__ + "img/audio.309dcdd6.svg";